import { Button } from "react-bootstrap";
import UserFormModal from "@/pages/shared/modal_forms/UserFormModal.jsx";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import $ from "jquery";
import languageES from "datatables.net-plugins/i18n/es-MX.js";
import api from "@/api/api.js";
import axiosRoot from "@/api/axios.js";
import { ROLES } from "@/config/roles.js";
import Swal from "sweetalert2";

const UsersInternal = () => {
  const tableRef = useRef(null);
  const dataTable = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const roles = useSelector((state) => state.auth.roles);
  const isSuperAdmin = roles?.includes(ROLES.SUPER_ADMIN);

  const handleSendRecovery = (email) => {
    Swal.fire({
      title: "¿Enviar correo de recuperación?",
      text: `Se enviará un enlace de restablecimiento a ${email}.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, enviar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      axiosRoot
        .post("/forgot-password", { email })
        .then(() =>
          Swal.fire("Enviado", "Se envió el correo de recuperación.", "success"),
        )
        .catch((error) =>
          Swal.fire(
            "Error",
            error?.response?.data?.error ||
              "No se pudo enviar el correo de recuperación.",
            "error",
          ),
        );
    });
  };

  const handleOpenModal = (userId = null) => {
    setSelectedUserId(userId);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    if (dataTable.current) {
      dataTable.current.ajax.reload();
    }
  };

  const handleSave = () => {
    handleCloseModal();
  };

  function handleDelete(userId) {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esta acción",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, borrarlo",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        api
          .delete(`/users/${userId}`)
          .then(() => {
            dataTable.current.ajax.reload();
            Swal.fire("¡Borrado!", "El usuario ha sido eliminado.", "success");
          })
          .catch((error) => {
            console.error("Error deleting user:", error);
            Swal.fire(
              "Error",
              "Hubo un problema al eliminar el usuario.",
              "error",
            );
          });
      }
    });
  }

  useEffect(() => {
    dataTable.current = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      language: languageES,
      ajax: async (dataTablesParams, callback) => {
        try {
          const response = await api.get("/users", {
            params: {
              page: dataTablesParams.start / dataTablesParams.length + 1,
              itemsPerPage: dataTablesParams.length,
              search: dataTablesParams.search.value,
              staff: 1,
            },
          });

          callback({
            data: response.data["hydra:member"],
            recordsTotal: response.data["hydra:totalItems"],
            recordsFiltered: response.data["hydra:totalItems"],
          });
        } catch (error) {
          console.error("Error al cargar datos:", error);
          callback({ data: [] });
        }
      },
      columns: [
        {
          title: "Nombre",
          render: (data, type, row) => {
            if (!row.userProfile) return "-";
            return `${row.userProfile.name ?? ""} ${row.userProfile.lastname ?? ""}`.trim() || "-";
          },
        },
        {
          title: "Tipo",
          render: (data, type, row) => row.userProfile?.userType ?? "-",
        },
        { title: "email", data: "username" },
        {
          title: "Acciones",
          orderable: false,
          searchable: false,
          className: "text-nowrap",
          render: function (data, type, row) {
            const recovery = `<button class="btn btn-sm btn-outline-secondary btn-recovery-user-internal" data-email="${row.username}" title="Enviar correo de recuperación"><i class="bi bi-envelope"></i></button>`;
            const del = isSuperAdmin
              ? `<button class="btn btn-sm btn-outline-danger btn-delete-user-internal" data-id="${row.id}" title="Borrar"><i class="bi bi-trash"></i></button>`
              : "";
            return `<div class="d-flex gap-1">${recovery}${del}</div>`;
          },
        },
        { title: "Última actualización", data: "createdAtAgo" },
      ],
    });

    $(tableRef.current).on("click", ".btn-recovery-user-internal", function () {
      const email = $(this).data("email");
      handleSendRecovery(email);
    });

    $(tableRef.current).on("click", ".btn-delete-user-internal", function () {
      const userId = $(this).data("id");
      handleDelete(userId);
    });

    return () => {
      const table = $(tableRef.current);
      table.off("click", ".btn-recovery-user-internal");
      table.off("click", ".btn-delete-user-internal");

      if (dataTable.current) {
        dataTable.current.destroy();
      }
    };
  }, []);

  return (
    <>
      <div className="col">
        <div className="card">
          <div className="card-body p-1">
            <div className="card-title p-1">
              <h5 className="card-title p-1">Lista de usuarios</h5>
            </div>
            <div className={"card-body"}>
              <table
                ref={tableRef}
                className="display"
                style={{ width: "100%" }}
              ></table>
            </div>
            <div>
              <Button onClick={() => handleOpenModal()}>Crear Usuario</Button>

              <UserFormModal
                show={showModal}
                handleClose={handleCloseModal}
                selectedUserId={selectedUserId}
                onSave={handleSave}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UsersInternal;
